export const EVENT_ROUTE_CHANGE = 'gatsby-route-change';
export const EVENT_GA = 'GAEvent';
export const EVENT_SHARE = 'share';
export const EVENT_PURCHASE = 'purchase';

export const FORM_START = 'form_start';
export const FORM_SENT = 'form_sent';

export const CATEGORY_EGEN_INSAMLING = 'Egen insamling';
export const CATEGORY_NAVIGATION = 'Navigation';
export const CATEGORY_PROMO_FULL_WIDTH = 'Promo (Full width)';
export const CATEGORY_SEARCH = 'Search';

export const ACTION_FUNDRAISER_STARTED = 'Fundraiser started';
export const ACTION_LINK_CLICK = 'Clicked link';
export const ACTION_BTN_CLICK = 'Clicked button';

export const METHOD_FACEBOOK = 'Facebook';
export const METHOD_LINKEDIN = 'Linkedin';
export const METHOD_EMAIL = 'Email';

export const GIFT_TYPE_FUNDRAISER_DONATION = 'fundraiser_donation';
